import { create } from "zustand";

interface AppBadgesStore {
  badges: Record<string, number>;
  incrementBadge: (appId: string) => void;
  clearBadge: (appId: string) => void;
}

export const useAppBadgesStore = create<AppBadgesStore>((set) => ({
  badges: {},
  incrementBadge: (appId) =>
    set((state) => ({
      badges: {
        ...state.badges,
        [appId]: (state.badges[appId] ?? 0) + 1,
      },
    })),
  clearBadge: (appId) =>
    set((state) => ({
      badges: {
        ...state.badges,
        [appId]: 0,
      },
    })),
}));
